export const FormatDate = (date_time: string) => {
    const date = new Date(date_time);
    const options: Intl.DateTimeFormatOptions = { month: "short", day: '2-digit', year: 'numeric' };

    return date.toLocaleDateString(undefined, options);
} 